export const MODULE_NAME = 'reviews';
export const PAGE_SIZE = 10;
